// Centralized route configuration
export const ROUTES = {
  VIEW: '/',
  EDIT: '/spg-edit',
  PUBLISH: '/spg-publish',
  SUBSCRIPTION: '/spg-subscription',
  PAGES: '/spg-pages',
  FILES: '/spg-files',
  SETTINGS: '/spg-settings',
  HISTORY: '/spg-history',
  NOT_FOUND: '/spg-notfound',
}; 
